import React, { useEffect, useState } from "react";
import styles from "../../styles/dashboard/overview.module.css";
import socialLogo from "../../assets/images/social.svg";
import governanceLogo from "../../assets/images/governance.svg";
import evnironmentLogo from "../../assets/images/environment.svg";
import { Button, Switch } from "@mui/material";
import GlobalChart from "../../Components/GraphNCharts/GlobalChart";
import { Link } from "react-router-dom";
import Environment from "../../Components/OverviewDashboard/Environment";
import Social from "../../Components/OverviewDashboard/Social";
import Governance from "../../Components/OverviewDashboard/Governance";
import TableChart from "../../Components/GraphNCharts/TableChart";
import { useUser } from "../../context/AuthContext";
import { api, get } from "../../utils/api";
import { companyId } from "../../utils/companyId";
import useAuthStore from "../../store/ContextUser";
import InitialQuestionareSidebar from "../../Layout/InitialQuestionareSidebar";
import FeatureLockedModal from "../../Components/Common/FeatureLockedModal";

const Overview = () => {
  const { user } = useUser();
  const { selectedCompany } = useAuthStore();
  const [currentComponent, setCurrentComponent] = useState("environment");
  const [currentYear, setCurrentYear] = useState(true);
  const [month, setMonth] = useState("1M");
  const [tableData, setTableData] = useState();
  const currentYearDate = new Date().getFullYear();
  const [year, setYear] = useState("");
  const [featureLockedModal, setFeatureLockedModal] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(
          `${api}/esg-baseline/${companyId}?companyId=${selectedCompany?._id}`
        );
        setYear(response?.data?.data?.year);
      } catch (err) {
        console.error("Error:", err);
      }
    };
    fetchData();
  }, [selectedCompany]);

  const cards = [
    {
      id: 1,
      title: "Environment",
      description:
        "Achieve environmental sustainability with data-driven insights and performance tracking.",
      icon: evnironmentLogo,
      url: "/environment/dashboard",
    },
    {
      id: 2,
      title: "Social",
      description:
        "Enhance social responsibility, employee well-being, and community engagement with actionable insights.",
      icon: socialLogo,
      url: "/social/dashboard",
    },
    {
      id: 3,
      title: "Governance",
      description:
        "Ensure accountability with insights on governance, risk management, and transparency.",
      icon: governanceLogo,
      url: "/governance/dashboard",
    },
  ];

  let durationObj = [
    { id: "1M", label: "Current Month" },
    { id: "6M", label: "Last 6 Months" },
    { id: "12M", label: "Last 12 Months" },
  ];

  const fetchGlobalData = async () => {
    try {
      let response = await get(
        `dashboard/globalEmission/overview?timeFrame=${month}&companyId=${selectedCompany?._id}`
      );
      setTableData(response?.data?.data);
    } catch (error) {}
  };

  useEffect(() => {
    fetchGlobalData();
  }, [month]);

  return (
    <>
      {/* <p className={styles.title}>Dashboard</p> */}
      <div className={styles.dashboard}>
        <div className={styles.dashboard_header}>
          <h1 className={styles.dashboard_title}>Dashboard</h1>
          <div className={styles.dashboard_header_right}>
            {/* <div > */}
            <img
              src={
                user?.groupManager
                  ? user?.groupCompanyId?.image
                  : user?.company?.companyImage
              }
              alt={user?.groupManager ? "groupadmin" : "company"}
              className={styles.company_image}
            />
            {/* </div> */}
            <div className={styles.company_name_wrapper}>
              {(user?.groupManager
                ? user?.groupCompanyId?.groupName
                : user?.company?.companyName
              )
                ?.split(" ")
                .map((word, idx) => (
                  <React.Fragment key={idx}>
                    {word}
                    {(idx + 1) % 2 === 0 ? <br /> : " "}
                  </React.Fragment>
                ))}
            </div>
          </div>
        </div>
        <div className={styles.dashboard_cards}>
          {cards.map((card) => {
            const buttonStyles = {
              backgroundColor: "rgba(28, 72, 107, 1)",
              fontFamily: "Inter",
              fontSize: "14px",
              fontWeight: "600",
              textTransform: "none",
              color: "#fff",
            };

            return (
              <div key={card.id} className={styles.card}>
                <div>
                  <img
                    src={card.icon}
                    alt={card.title}
                    // className={styles.card_icon}
                  />
                  <h2 className={styles.card_title}>{card.title}</h2>
                  <p className={styles.card_description}>{card.description}</p>
                </div>
                {card.title === "Social" || card.title === "Governance" ? (
                  user?.isTrialUser ? (
                    <div style={{ textDecoration: "none" }}>
                      <Button
                        variant="contained"
                        style={buttonStyles}
                        onClick={() => {
                          setFeatureLockedModal(true);
                          setCurrentComponent(card.title.toLowerCase());
                        }}
                      >
                        Dashboard
                      </Button>
                    </div>
                  ) : (
                    <Link to={card.url} style={{ textDecoration: "none" }}>
                      <Button variant="contained" style={buttonStyles}>
                        Dashboard
                      </Button>
                    </Link>
                  )
                ) : (
                  <Link to={card.url} style={{ textDecoration: "none" }}>
                    <Button variant="contained" style={buttonStyles}>
                      Dashboard
                    </Button>
                  </Link>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* country table  */}
      <div>
        <div className={styles.card_container_map}>
          <div className={styles.card_container_map_one}>
            <p className={styles.card_heading}>Emission by location</p>
            <div style={{ display: "flex", gap: "12px" }}>
              <select
                name="month"
                id="month"
                value={month}
                onChange={(e) => setMonth(e.target.value)}
                className={styles.heading_select_month}
              >
                {durationObj.map((m) => (
                  <option key={m?.id} value={m?.id}>
                    {m?.label}
                  </option>
                ))}
              </select>

              {/* <select
                name="year"
                id="year"
                value={year}
                onChange={(e) => setYear(e.target.value)}
                className={styles.heading_select_year}
              >
                {["World"].map((y) => (
                  <option key={y} value={y}>
                    {y}
                  </option>
                ))}
              </select> */}
            </div>
          </div>
          <div className={styles.global_travel_container}>
            <div className={styles.global_travel_table}>
              <TableChart tableData={tableData} />
            </div>
            <div className={styles.global_travel_graph}>
              <GlobalChart tableData={tableData} />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.button_container}>
        <div className={styles.button_container_div}>
          <button
            className={
              currentComponent === "environment"
                ? styles.button_active
                : styles.button_inactive
            }
            onClick={() => setCurrentComponent("environment")}
          >
            Environment
          </button>

          <button
            className={
              currentComponent === "social"
                ? styles.button_active
                : styles.button_inactive
            }
            onClick={() => setCurrentComponent("social")}
          >
            Social
          </button>

          <button
            className={
              currentComponent === "governance"
                ? styles.button_active
                : styles.button_inactive
            }
            onClick={() => setCurrentComponent("governance")}
          >
            Governance
          </button>
        </div>
        <div className={styles.button_container_switch}>
          {/* <p
            className={
              currentYear ? styles.switch_inactive : styles.switch_active
            }
          >
            Current Year
          </p>
          <Switch
            checked={currentYear}
            onChange={() => setCurrentYear(!currentYear)}
          />
          <p
            className={
              currentYear ? styles.switch_active : styles.switch_inactive
            }
          >
            Baseline
          </p> */}
          <p
            className={
              currentYear ? styles.switch_active : styles.switch_inactive
            }
          >
            Baseline ({year})
          </p>
          <Switch
            checked={!currentYear}
            onChange={() => setCurrentYear(!currentYear)}
          />
          <p
            className={
              currentYear ? styles.switch_inactive : styles.switch_active
            }
          >
            Current Year ({currentYearDate})
          </p>
        </div>
      </div>

      {currentComponent === "environment" ? (
        <Environment currentYear={currentYear} />
      ) : currentComponent === "social" ? (
        <Social currentYear={currentYear} />
      ) : currentComponent === "governance" ? (
        <Governance currentYear={currentYear} />
      ) : null}

      {/* Feature Locked Modal */}
      {user?.isTrialUser && (
        <FeatureLockedModal
          open={featureLockedModal}
          onClose={() => setFeatureLockedModal(false)}
        />
      )}

      {/* <InitialQuestionareSidebar /> */}
    </>
  );
};

export default Overview;
